import { Box, styled } from '@mui/material';
import MultiOrSingleOrgSelect from 'components/MultiOrSingleOrgSelect';
import {
  RadioGroupControl,
  SectionTitle,
  TextV2,
} from '@insights-ltd/design-library/components';
import OrganisationIcon from 'components/Svgs/icons/Organisation';
import { InviteUserOrgOptions } from 'types/types';
import { useTranslation } from 'react-i18next';
import { Group, GroupResponse, OrganisationResponse } from 'api';
import { GroupOrganisationHashMap } from 'utils/createGroupOrganisationMap';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';

const StyledOrganisationIcon = styled(OrganisationIcon)(({ theme }) => ({
  fill: theme.palette.orange.dark,
  height: '20px',
}));

const AddUserOptions = ({
  selectedOrgs,
  setSelectedOrgs,
  orgType,
  setOrgType,
  groups,
  organisationsInGroups,
  onRemoveOrg,
  setSelectedGroup,
  selectedGroup,
  titleKey,
  options,
  existingUser = false,
  onlySpecialHandling = false,
}: {
  options: { label: string; value: InviteUserOrgOptions }[];
  onRemoveOrg: (id: string) => void;
  selectedOrgs: any;
  setSelectedOrgs: (org: OrganisationResponse | null) => void;
  orgType: InviteUserOrgOptions;
  setOrgType: (type: InviteUserOrgOptions) => void;
  groups: GroupResponse[];
  organisationsInGroups: GroupOrganisationHashMap;
  selectedGroup: Group | null;
  setSelectedGroup: (value: GroupResponse | null) => void;
  titleKey?: string;
  groupOptions: OrganisationResponse[];
  existingUser?: boolean;
  onlySpecialHandling?: boolean;
}) => {
  const { t } = useTranslation();
  const title = titleKey ?? 'ui.event-management.users.create.organisation';

  return (
    <>
      <Box
        sx={{
          mt: existingUser ? '1.5rem' : spacingSizeMap.L,
          mb: spacingSizeMap.M,
        }}
      >
        <SectionTitle
          icon={{ icon: <StyledOrganisationIcon />, iconColour: 'orange' }}
          text={t(title, { count: 1 })}
        />
      </Box>
      <TextV2 component="span" variant="bodyBold">
        {t('ui.event-management.users.invite.select-option.label')}
      </TextV2>
      <RadioGroupControl
        name="org type"
        onChange={(newValue: any) => {
          setOrgType(newValue);
          setSelectedOrgs(null);
        }}
        title={t('ui.event-management.users.invite.select-option.title')}
        variant="list"
        value={orgType}
        options={options}
      />
      <Box
        sx={{
          mt: 2,
          mb: 2,
        }}
      >
        <MultiOrSingleOrgSelect
          orgType={orgType}
          selectedOrgs={selectedOrgs}
          setSelectedOrgs={setSelectedOrgs}
          groups={groups}
          organisationsInGroups={organisationsInGroups}
          onRemoveOrg={onRemoveOrg}
          setSelectedGroup={setSelectedGroup}
          selectedGroup={selectedGroup}
          onlySpecialHandling={onlySpecialHandling}
        />
      </Box>
    </>
  );
};

export default AddUserOptions;
